import { createSelector } from 'reselect';
import { State } from '.';
import {
    PatientRx,
    RxStatus
} from '../../models/patient-rx';

const getPatientRxHashSelector = createSelector(
    (state: State) => state.byMedId,
    (byMedId: Dictionary<PatientRx>) => Object
        .keys(byMedId)
        .reduce(
            (prevValue, x) => {
                prevValue[x] = {
                    id: x,
                    refId: byMedId[x]!.medId,
                    action: '',
                    date: byMedId[x]!.createdDate,
                    priority: byMedId[x]!.status === RxStatus.NotTaking ? 1 : 0,
                    ref: byMedId[x]!.status === RxStatus.Taking || byMedId[x]!.status === RxStatus.NotTaking
                } as PatientPortalDataMerge;
                return prevValue;
            },
            {} as Dictionary<PatientPortalDataMerge>
        )
);

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getPatientRx: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<PatientRx> => state.byId[id || ''],
    getPatientRxByMed: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<PatientRx> => state.byMedId[id || ''],
    getPatientRxHash: (
        state: State
    ): Dictionary<PatientPortalDataMerge> => getPatientRxHashSelector(state),
    getPatientRxIds: (
        state: State
    ): number[] => state.allIds
};
